import * as types from './types';

const initialState = {
	primaryLite: {},
	primary: ''
};

const primaryImageReducer = (state = initialState, action) => {
	const primary = action.payload;
	switch (action.type) {
		case types.START_CAPTURE: {
			return {
				...state,
				primary
			};
		}
		case types.GET_PRIMARY: {
			return {
				...state,
				primary: '',
				primaryLite: primary
			};
		}
		case types.RESET_CAPTURE:
			return initialState;
		default:
			return state;
	}
};
export default primaryImageReducer;
